function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M295.061 1027.13L162.332 903.732C43.239 1066.12 -9.4517 1219.61 1.38453 1401.1C33.8955 1343.03 145.881 1154.28 295.061 1027.13Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M629.172 722.26C933.369 439.206 1114.32 0 498.835 0C-116.649 0 23.3747 631.524 240.139 831.143C456.903 1030.76 421.856 1000.32 606.287 1172.45C790.718 1344.58 1103.15 1912.9 574.249 1912.9C45.3499 1912.9 261.475 1466.44 523.904 1252.16L395.752 1132.39C1.38728 1506.37 -144.317 2010.72 574.249 1999.83C1177.62 1990.68 1215.13 1502.56 749.14 1041.75C668.705 962.212 461.474 753.995 369.845 671.311C136.565 460.803 217.462 79.8556 498.835 79.8556C780.208 79.8556 789.362 312.133 498.835 595.229L629.172 722.26Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M723.244 805.827L855.973 929.229C975.066 766.837 1027.76 613.349 1016.92 431.859C984.409 489.935 872.424 678.685 723.244 805.827Z",
  fill: "black"
});

var SvgShayrLogo = function SvgShayrLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1067,
    height: 2000,
    viewBox: "0 0 1067 2000",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShayrLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shayr-logo.6e5e9a16.svg";
export { ForwardRef as ReactComponent };